const Logo = () => <img alt="Logo" src="/static/images/star_icon.svg" />;

export default Logo;
